import { SolNavbar, SolNavbarItem, SolRouteId } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

// A kind's list entry opens a sample asset; its detail child names the asset and shows the tabs in the topbar
const assetItem = (
  listRouteId: SolRouteId,
  detailRouteId: SolRouteId,
  tabs: [SolRouteId, string][],
  displayName: string,
  icon: SolIcon,
): SolNavbarItem =>
  SolNavbarItem.of(listRouteId, {
    displayName,
    icon,
    showChildrenInNavbar: false,
    children: [
      SolNavbarItem.of(detailRouteId, {
        displayName: 'asm-prototype.asset-details.asset.name',
        nameParams: ['assetName'],
        showChildrenAsTabs: tabs.length > 0,
        children: tabs.map(([routeId, tabName]) => SolNavbarItem.of(routeId, { displayName: tabName })),
      }),
    ],
  });

export const assetDetailsNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.asset_details_assets, {
      displayName: 'Assets',
      icon: SolIcon.asm_assets,
      children: [
        assetItem(
          PrototypeRouteId.asset_details_certificates,
          PrototypeRouteId.asset_details_certificate,
          [
            [PrototypeRouteId.asset_details_certificate_overview, 'Overview'],
            [PrototypeRouteId.asset_details_certificate_findings, 'Findings'],
            [PrototypeRouteId.asset_details_certificate_scoring, 'Scoring'],
          ],
          'Certificates',
          SolIcon.asm_certificates,
        ),
        assetItem(
          PrototypeRouteId.asset_details_domain_discovery,
          PrototypeRouteId.asset_details_domain_candidate,
          [
            [PrototypeRouteId.asset_details_domain_candidate_overview, 'Overview'],
            [PrototypeRouteId.asset_details_domain_candidate_activity, 'Activity'],
          ],
          'Domain discovery',
          SolIcon.asm_domain_discovery,
        ),
        assetItem(
          PrototypeRouteId.asset_details_domains,
          PrototypeRouteId.asset_details_domain,
          [
            [PrototypeRouteId.asset_details_domain_overview, 'Overview'],
            [PrototypeRouteId.asset_details_domain_findings, 'Findings'],
            [PrototypeRouteId.asset_details_domain_scoring, 'Scoring'],
          ],
          'Domains',
          SolIcon.asm_domains,
        ),
        assetItem(
          PrototypeRouteId.asset_details_hosts,
          PrototypeRouteId.asset_details_host,
          [
            [PrototypeRouteId.asset_details_host_overview, 'Overview'],
            [PrototypeRouteId.asset_details_host_findings, 'Findings'],
            [PrototypeRouteId.asset_details_host_scoring, 'Scoring'],
            [PrototypeRouteId.asset_details_host_scan_history, 'Scan history'],
          ],
          'Hosts',
          SolIcon.asm_hosts,
        ),
        assetItem(
          PrototypeRouteId.asset_details_websites,
          PrototypeRouteId.asset_details_website,
          [
            [PrototypeRouteId.asset_details_website_overview, 'Overview'],
            [PrototypeRouteId.asset_details_website_findings, 'Findings'],
            [PrototypeRouteId.asset_details_website_scoring, 'Scoring'],
          ],
          'Websites',
          SolIcon.asm_websites,
        ),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_preferences, { displayName: 'Preferences' })],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
